// extracted by mini-css-extract-plugin
module.exports = {"container":"Bio-module--container--2cCAN","container__text":"Bio-module--container__text--2ul-9","image__container":"Bio-module--image__container--2Akmy"};